//**Presentación del proyecto INEGI

//*react- recursos

//*componentes-utiles
/* import CargaArchivo from "../../../componentes/CargaArchivo"; */

//*clases 

//*datos
  import etiquetasSSC from "../../datos/json/etiquetasSSC.json"

//*archivos (imagenes y elementos necesarios para la rutina)
  import logoInegi from '../../imagenes/inegi/INEGI_LogoH.png';

//*api's (servicios y store)

//*store's

//*funciones

//*interfaces 

//*componente

//*componente
  export default function Presentacion() {
    //*api store

    //*store's
    
    //*data 
      let eti = etiquetasSSC.Presentacion;
    //*constantes y variables

    //*usestate

    //*useEffect

    //* interface (parametros de entrada)

    //*funciones

    //*vista
        return(
          <>
            <div className="homeFather">
                <div className=" ">
                    <h2 className="mb-3">
                        {/* <img src={logoInegi} alt="logo INEGI" className="logoInegi2" /> */}
                        <div className="imagenPres"></div>
                    </h2>
                    <p className="text-justify">
                    <div className="display-flex">
                        <div className='margin-5rem'>
                            <span className="h4 color-white"> {eti[0].text}&nbsp; </span>
                            <span className="h6 color-white"> {eti[1].text} </span>
                        </div>
                    </div>
                    </p>
                </div>
            </div>
          </>     
        );
  }